import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../App.css";
import InfluencerHeader from "./InfluencerHeader";
import Navbar from "./Navbar";

const AffiliateNotifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  const influencerId = localStorage.getItem("influencerID");
  const notificationsPerPage = 10;

  useEffect(() => {
    if (!influencerId) {
      setError("Influencer ID not found in localStorage.");
      setLoading(false);
      return;
    }

    const fetchNotifications = async () => {
      try {
        const response = await fetch(
          `https://server-side-influencer.onrender.com/influencer/affilatesnotifications/${influencerId}`);

        if (!response.ok) {
          throw new Error("Failed to fetch notifications");
        }

        const data = await response.json();

        setNotifications(data.notifications || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchNotifications();
  }, [influencerId]);

  const handleDeleteNotification = async (notificationId) => {
    console.log("notiata a ffilate iud ",notificationId)
  try {
    const response = await fetch(
      `https://server-side-influencer.onrender.com/influencer/affilatesnotificationdelete/${influencerId}/${notificationId}`,
      {
        method: "DELETE",
      }
    );

    const data = await response.json();

    if (data.success) {
      setNotifications((prev) =>
        prev.filter((n) => n._id !== notificationId)
      );
      toast.success("Notification deleted successfully!");
    } else {
      toast.error("Failed to delete notification.");
    }
  } catch (err) {
    toast.error("Error deleting notification: " + err.message);
  }
};

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 760);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const indexOfLast = currentPage * notificationsPerPage;
  const indexOfFirst = indexOfLast - notificationsPerPage;
  const currentNotifications = notifications.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(notifications.length / notificationsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="flex flex-col h-screen">
      {/* Header */}
      <div className="fixed top-0 left-0 right-0 z-40 bg-white shadow-md">
        <InfluencerHeader page="Notifications" />
      </div>

      {/* Content Area sssss*/}
      <div className="flex flex-1 page-scroll pt-20">
        {/* Sidebar */}
        <div className="text-white fixed top-0 left-0 bottom-0 z-50">
          <Navbar />
        </div>

        {/* Main Content */}
        <div
          className="flex-1 p-6 mt-0"
          style={{
            marginLeft: isSmallScreen ? "0px" : "43px",
          }}
        >
          <h1 className="text-2xl font-bold mb-6 mt-0 ml-6">Notifications</h1>

          {/* Notification List */}
          <div>
            {loading ? (
              Array.from({ length: 5 }).map((_, index) => (
                <div
                  key={index}
                  className="bg-white rounded-lg p-5 shadow-lg flex justify-between items-center gap-4 mb-4 ml-5"
                >
                  <div className="flex-1">
                    <Skeleton height={20} width={`80%`} />
                  </div>
                  <Skeleton circle width={30} height={30} />
                </div>
              ))
            ) : error ? (
              <p className="text-xl text-red-500 mb-2">{error}</p>
            ) : currentNotifications.length === 0 ? (
              <p className="text-xl mb-2 ml-6">No new notifications</p>
            ) : (
              currentNotifications.map((notification) => (
                <div
                  key={notification._id}
                  className="bg-white rounded-lg p-5 shadow-lg flex justify-between items-center gap-4 mb-4 ml-5"
                >
                  <span className="font-semibold text-base text-gray-800">
                    {notification.message}
                  </span>
                  <IconButton
                 onClick={() => handleDeleteNotification(notification._id)}

                    color="error"
                  >
                    <DeleteIcon />
                  </IconButton>
                </div>
              ))
            )}
          </div>

          {/* Pagination */}
          {totalPages > 1 && !loading && (
            <div className="mt-4 flex justify-center space-x-4">
              <button
                onClick={() => paginate(currentPage - 1)}
                disabled={currentPage === 1}
                className="px-4 py-2 bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl font-medium rounded-lg text-sm text-white"
              >
                Previous
              </button>

              <span className="px-4 py-2 text-xl">{`Page ${currentPage}`}</span>

              <button
                onClick={() => paginate(currentPage + 1)}
                disabled={
                  currentPage * notificationsPerPage >= notifications.length
                }
                className="px-4 py-2 bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl font-medium rounded-lg text-sm text-white"
              >
                Next
              </button>
            </div>
          )}
        </div>
      </div>

      <ToastContainer position="top-right" autoClose={5000} />
    </div>
  );
};

export default AffiliateNotifications;
